// extracted by mini-css-extract-plugin
export default {"dataTable":"styles_data-table_X2FZp","pager":"styles_pager_tczgv","table":"styles_table_ElEtk"};